module.exports = __webpack_public_path__ + "img/トヨタ.96039f42.png";